import { Component, OnInit } from '@angular/core';
import {PlacementTestFilter, PlacementTestModel} from '../../models/edu-admin/placement-test.model';
import {CountryModel} from '../../models/localization-and-pricing/country.model';
import {AdminPlacementTestService} from '../../services/admin/admin-placement-test.service';
import {ModalService} from '../../shared/modals/modal/modal.service';
import {Router} from '@angular/router';
import {CultureModel} from '../../models/localization-and-pricing/culture.model';
import {EVOPlacementTestListSort} from '../../shared/list-views/evo-placement-tests-list-view/evo-placement-tests-list-view.component';

@Component({
  selector: 'app-admin-placement-test',
  templateUrl: './admin-placement-test.component.html',
  styleUrls: ['./admin-placement-test.component.css']
})
export class AdminPlacementTestComponent implements OnInit {

  CultureModel = CultureModel;
  placementTests: PlacementTestModel[] = [];

  filter = new PlacementTestFilter();
  hasMoreData = false;

  countryDropdownList = CountryModel.privateDropdownList(true);

  showCreatePlacementTest = false;
  newPlacementTest = new PlacementTestModel();

  constructor(private placementSv: AdminPlacementTestService,
              private modalSv: ModalService,
              private router: Router) { }

  ngOnInit() {

    this.filter.limit = 20;
    this.filter.sort = 1;
    this.filter.isArchived = false;

    this.fetchPlacementTests();

  }

  fetchPlacementTests() {

    this.filter.skip = this.placementTests.length;
    this.placementSv.fetchPlacementTests(this.filter).subscribe((placements) => {

      this.hasMoreData = placements.length === this.filter.limit;
      this.placementTests.addUniqueArrayElements(placements);

    });

  }

  searchFilteredPlacementTests(name: string, country: string) {

    this.filter.name = name;
    this.filter.country = country;
    this.placementTests = [];

    this.fetchPlacementTests();

  }

  onPlacementTestClicked(placement: PlacementTestModel) {
    this.router.navigate(['admin', 'placementTests', placement._id, 'detail', 'structure']);
  }

  onSortChanged(sort: EVOPlacementTestListSort) {

    this.filter.sort = sort.value;
    this.filter.skip = 0;
    this.placementTests = [];

    this.fetchPlacementTests();

  }

  onCreatePlacementTest() {

    this.placementSv.createPlacementTest(this.newPlacementTest).subscribe((placement) => {

      this.placementTests = [];
      this.fetchPlacementTests();
      this.showCreatePlacementTest = false;

    });

  }

  viewArchivedPlacementTests() {
    this.router.navigate(['admin', 'placementTestsArchived']);
  }

}
